"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _index = _interopRequireDefault(require("./index"));
var _CheckboxBase = _interopRequireDefault(require("./CheckboxBase"));
var _excluded = ["className", "InputProps"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _InputProps$menu;
  var className = _ref.className,
    _ref$InputProps = _ref.InputProps,
    InputProps = _ref$InputProps === void 0 ? {} : _ref$InputProps,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var multiOptions = ((_InputProps$menu = InputProps.menu) === null || _InputProps$menu === void 0 ? void 0 : _InputProps$menu.length) > 1;
  var _useContext = (0, _react.useContext)(_context["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona;
  return /*#__PURE__*/_react["default"].createElement(_index["default"], Object.assign({
    disableButtonPaper: !multiOptions
  }, props, {
    className: (0, _clsx["default"])((props.classNames || additionalStyles.input || defaultStyle).checkbox, className),
    ref: ref,
    InputComponent: _CheckboxBase["default"],
    InputProps: InputProps
  }));
});